module.exports = __webpack_public_path__ + "static/media/pencil_link.b8d54869.png";